import React, { useContext, useEffect, useState } from 'react'
import { Divider, Grid, TextField, Typography, FormControl, InputLabel, MenuItem, Select, makeStyles } from '@material-ui/core';
import { backGroundList } from '../../../../constants/globalConst';
import { UserContext } from '../../../../context/UserProvider';
import moment from 'moment';
import UpdatingButton from './ConfigComponents/UpdatingButton';
import DialogConfirm from './ConfigComponents/DialogConfirm';
import { db } from '../../../../config/firebase';
import 'moment/locale/es';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    position: 'relative',
    width: "37%",
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('sm')]: {
      width: "100%", // Ocupa todo el ancho en pantallas pequeñas
    },
  },
}));

const parameterOptions = [
  { id: "DPV", alias: "Déficit de Presión de Vapor (DPV)" },
  { id: "DLI", alias: "Daily Light Integral (DLI)" }
];

export const ConfigCalculatedParameter = (propiedades) => {
  const classes = useStyles();
  const data = propiedades.data;
  const ide = data.ide;
  const arrayDeCadenas = ide.split("@");
  const parameterId = arrayDeCadenas[3];
  const macId = arrayDeCadenas[0];
  
  const { usuario, userTimezone } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [openWindow, setOpenWindow] = useState(false);
  const [newName, setNewName] = useState('');
  const [lastUpdate, setLastUpdate] = useState("");
  const [selectedParameter, setSelectedParameter] = useState("DPV");
  const [updateInterval, setUpdateInterval] = useState("60");
  const [sourceNodes, setSourceNodes] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleNameChange = (e) => {
    setNewName(e.target.value);
  };

  const handleParameterChange = (e) => {
    setSelectedParameter(e.target.value);
  };

  const handleUpdateIntervalChange = (e) => {
    if (e.target.value >= 0) {
      setUpdateInterval(e.target.value);
    }
  };

  const editar = async (e) => {
    e.preventDefault();

    if (!newName.trim()) {
      setError("Ingrese Nombre");
      return;
    }
    setError(null);
    setOpenWindow(true);
  };

  const agreeDialog = async () => {
    setLoading(true);
    try {
      const item = {
        name: newName,
        parameterType: selectedParameter,
        updateInterval: Number(updateInterval),
        fecha: Date.now(),
        uid: ide
      };

      const addr = `${usuario.username}/calculatedParameters/${parameterId}`;
      await db.collection(addr).doc("config").set({ item });

      // Enviar configuración a través de MQTT si es necesario
      // Código para enviar configuración

      setLastUpdate(Date.now());
      setOpenWindow(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const obtenerDatos = async () => {
      try {
        const addr = `${usuario.username}/calculatedParameters/${parameterId}/config`;
        
        const docRef = db.collection(addr).doc("config");
        const docSnap = await docRef.get();

        if (docSnap.exists && isMounted) {
          const data = docSnap.data().item;
          setNewName(data.name || "");
          setSelectedParameter(data.parameterType || "DPV");
          setUpdateInterval(data.updateInterval || 60);
          setLastUpdate(data.fecha || "");
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    obtenerDatos();

    return () => {
      isMounted = false;
    };
  }, [usuario.username, parameterId]);

  return (
    <>
      <div className="container mt-3">
        <form onSubmit={editar}>
          <div className="row">
            <div className="col-12">
              <ul className="list-group">
                <li
                  className="list-group-item"
                  style={{ background: backGroundList }}
                >
                  <div className="row">
                    <div className="col-10">
                      <h4 style={{ color: "white" }}>{newName}</h4>
                    </div>
                  </div>
                </li>
                <li className="list-group-item">
                  <div className="row">
                    <div className="col-6">ID del Parámetro:</div>
                    <div className="col-6">{parameterId}</div>
                  </div>

                  <div className="row">
                    <div className="col-6">Nombre:</div>
                    <div className="col-6">
                      <input
                        type="text"
                        placeholder="Ingrese Nombre"
                        className="form-control mb-2"
                        onChange={handleNameChange}
                        value={newName}
                      ></input>
                    </div>
                  </div>

                  {lastUpdate && (
                    <div className="row">
                      <div className="col-6">Última modificación:</div>
                      <div className="col-6">
                        {moment(lastUpdate).tz(userTimezone).format('ddd, D [de] MMM [de] YYYY, HH:mm [Hrs.]')}
                      </div>
                    </div>
                  )}

                  <div style={{ marginTop: '15px' }}>
                    <Divider />
                  </div>

                  {/* Formulario de configuración de parámetros calculados */}
                  <Grid container direction="column" spacing={3} alignItems="center">
                    <div style={{ marginBottom: '10px', textAlign: 'center', marginTop: '10px', fontWeight: 'bold', fontSize: '24px' }}>
                      Configuración de Parámetros Calculados
                    </div>

                    {/* Tipo de parámetro */}
                    <Grid item container spacing={2} alignItems="center" justifyContent="flex-start">
                      <Grid item xs={12} sm={4} justifyContent="flex-start">
                        <Typography variant="body1">Tipo de parámetro:</Typography>
                      </Grid>
                      <Grid item xs={12} sm={8} justifyContent="flex-start">
                        <FormControl variant="outlined" size="small" className={classes.formControl}>
                          <InputLabel id="parameter-type-label">Selecciona</InputLabel>
                          <Select
                            labelId="parameter-type-label"
                            id="parameter-type"
                            value={selectedParameter}
                            onChange={handleParameterChange}
                            label="Selecciona"
                          >
                            {parameterOptions.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.alias}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    {/* Intervalo de actualización */}
                    <Grid item container spacing={2} alignItems="center" justifyContent="flex-start">
                      <Grid item xs={12} sm={4} justifyContent="flex-start">
                        <Typography variant="body1">Intervalo de actualización:</Typography>
                      </Grid>
                      <Grid item xs={10} sm="auto">
                        <TextField
                          id="update-interval"
                          type="number"
                          variant="outlined"
                          size="small"
                          value={updateInterval}
                          onChange={handleUpdateIntervalChange}
                        />
                      </Grid>
                      <Grid item xs={2} sm="auto">
                        <Typography variant="body2">minutos</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            {error && (
              <div className="col-12 mt-3">
                <div className="alert alert-danger alert-block">{error}</div>
              </div>
            )}
          </div>

          <UpdatingButton type="submit" disabled={loading} />
        </form>

        <DialogConfirm
          open={openWindow}
          handleClose={() => setOpenWindow(false)}
          agreeDialog={agreeDialog}
          title={"¿Está seguro que quiere continuar con esta operación?"}
          text={
            "Se realizará un cambio en la configuración del parámetro calculado."
          }
        />
      </div>
    </>
  )
}

export default ConfigCalculatedParameter;
